import {
  FaTasks,
  FaUserPlus,
  FaSync
} from 'react-icons/fa';
import { RiDashboardFill } from "react-icons/ri";
import { FaFileCircleCheck } from "react-icons/fa6";





export const adminSidebar = [
  {
    name: "Dashboard",
    link: "/admin/dashboard",
    icon: RiDashboardFill,
  },
  {
    name: "Requests",
    icon: FaFileCircleCheck,
    children: [
      { name: "Onboarding Requests", link: "/admin/onboarding-requests", icon: FaUserPlus },
      { name: "Change Requests", link: "/admin/change-requests", icon: FaSync },
    ],
  },
]    